module.exports = {
  uk: {
    path: 'uk',
    countryISO: 'en-GB',
    locale: 'United Kingdom',
    default: true,
  },
  en: {
    path: 'en',
    countryISO: 'en',
    locale: 'Global',
  },
  se: {
    path: 'se',
    countryISO: 'en-SE',
    locale: 'Sweden',
  },
}
